import React from 'react';

const WorkflowTriggerFormModal = React.lazy(() => import('../components/FormModal'));
const workflowTriggerModalRegistry = {
    crm_workflowTriggerId: WorkflowTriggerFormModal
};
export default workflowTriggerModalRegistry;
